import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "mac";
const macActionNameGenerator = actionNameGenerator(domainPrefix);

export const initializeValuesType = macActionNameGenerator("initializeValues");

export const changeAccountType = macActionNameGenerator("changeAccountType");

export const changeAddressType = macActionNameGenerator("changeAddress");

export const changeAddressValueType = macActionNameGenerator("changeAddressValue");

export const changeAccountNumberType = macActionNameGenerator("changeAccountNumber");

export const changeFundDetailsType = macActionNameGenerator("changeFundDetails");

export const checkVGMutualFundType = macActionNameGenerator("checkVGMutualFund");

export const addMutualFundType = macActionNameGenerator("addMutualFund");

export const addnewFundDetailsType = macActionNameGenerator("addnewFundDetails");

export const clearfundDetailsType = macActionNameGenerator("clearfundDetails");

export const removeFundInfoType = macActionNameGenerator("removeFundInfo");

export const updateAOAccountNumberType = macActionNameGenerator("updateAOAccountNumber");

export const getZipCodeType = macActionNameGenerator("getZipCode");

export const updateLoggedinAddressType = macActionNameGenerator("updateLoggedinAddress");

export const allocationPreferenceType = macActionNameGenerator("allocationPreference");

export const UpdateFormInReducerType = macActionNameGenerator("UpdateFormInReducer");

export const resetAllocationPoolsType = macActionNameGenerator("resetAllocationPools");

export const switchExchangeUnitType = macActionNameGenerator("switchExchangeUnit");

export const updateFromTotalType = macActionNameGenerator("updateFromTotal");

export const updateFromFormFieldType = macActionNameGenerator("updateFromFormField");

export const updateRecordedValType = macActionNameGenerator("updateRecordedVal");

export const clearFormDataType = macActionNameGenerator("clearFormData");

export const removeContributionType = macActionNameGenerator("removeContributionType");

export const getAPIDataType = macActionNameGenerator("getAPIData");

export const createContributionType = macActionNameGenerator("createContribution");

export const updateContributionErrorType = macActionNameGenerator("updateContributionError");

export const updateContributionStatusType = macActionNameGenerator("updateContributionStatus");

export const updateContributionStatusJsonType = macActionNameGenerator("updateContributionStatusJson");

export const generateAccesKeyType = macActionNameGenerator("generateAccesKey");

export const step1EditType = macActionNameGenerator("step1Edit");

export const updateClearStatusType = macActionNameGenerator("updateClearStatus");

export const updateAutoFilledStatusType = macActionNameGenerator("updateAutoFilledStatus");

export const showErrorMessagesType = macActionNameGenerator("showErrorMessages");

export const updateErrorMessageType = macActionNameGenerator("updateErrorMessage");

export const updateAdditionalDataType = macActionNameGenerator("updateAdditionalData");

export const updateZipCodeValuesType = macActionNameGenerator("updateZipCodeValues");

export const updateZipCodeErrorMessageType = macActionNameGenerator("updateZipCodeErrorMessage");

export const updateSelectedTickerType = macActionNameGenerator("updateSelectedTicker");

export const contributionAccessKeyFailedType = macActionNameGenerator("contributionAccessKeyFailed");

export const contributionAccessKeySuccessType = macActionNameGenerator("contributionAccessKeySuccess");

export const postCreateContributionErrorType = macActionNameGenerator("postCreateContributionError");

export const postCreateContributionSuccessType = macActionNameGenerator("postCreateContributionSuccess");

export const contributionDataFailureType = macActionNameGenerator("contributionDataFailure");

export const makeAContributionDrupalData2Type = macActionNameGenerator("makeAContributionDrupalData2");

export const contributionYearWiseBalanceDetailsType = macActionNameGenerator("contributionYearWiseBalanceDetails");

export const contributionFundDetailsDataSuccessType = macActionNameGenerator("contributionFundDetailsDataSuccess");

export const contributionInvestmentDataSuccessType = macActionNameGenerator("contributionInvestmentDataSuccess");

export const contributionLoggedInAddressType = macActionNameGenerator("contributionLoggedInAddress");

export const contributionDropdownDataSuccessType = macActionNameGenerator("contributionDropdownDataSuccess");

export const contributionAccessKeyApiCalledType = macActionNameGenerator("contributionAccessKeyApiCalled");

export const makeAContributionDrupalDataType = macActionNameGenerator("makeAContributionDrupalData");

export const updateZipCodeType = macActionNameGenerator("updateZipCode");

export const relationShipDataSuccessType = macActionNameGenerator("relationShipData");

export const updateMacZipCodeSagaValuesType = macActionNameGenerator("updateMacZipCodeSagaValues");

export const fetchTickerType = macActionNameGenerator("fetchTicker");

export const fetchTickerSuccessType = macActionNameGenerator("fetchTickerSuccess");

export const fetchTickerFailureType = macActionNameGenerator("fetchTickerFailure");

export const fetchPriceType = macActionNameGenerator("fetchPrice");

export const fetchPriceSuccessType = macActionNameGenerator("fetchPriceSuccess");

export const fetchPriceFailureType = macActionNameGenerator("fetchPriceFailure");

export const clearPriceType = macActionNameGenerator("clearPrice");